import styled from '@emotion/styled'
import type { Dimension } from '@pubstack/common/src/analytics/dimension'
import type { AnalyticsQueryDashboard, ServerSideMetricsDetailByTime } from '@pubstack/common/src/analytics/query'
import { useAtomValue } from 'jotai'
import { DateTime } from 'luxon'
import type { FunctionComponent } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { ServerSideDetailBreakdown } from '~/modules/analytics/server-side/details/ServerSideDetailBreakdown'
import { ServerSideDetailCharts } from '~/modules/analytics/server-side/details/ServerSideDetailCharts'
import { contextState } from '~/state'

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const DIMENSIONS: Dimension[] = ['tagId', 'adUnit', 'country', 'size']
const SERVER_SIDE_DASHBOARD: AnalyticsQueryDashboard = {
  name: 'server-side',
  filterType: 'auctions',
}

const timelineEmptyData: ServerSideMetricsDetailByTime = {
  epoch: [],
  serverSideImpressionCount: [],
  serverSideImpressionCpmSum: [],
  serverSideBidRequestCount: [],
  serverSideBidResponseCount: [],
  serverSideBidTimeoutCount: [],
  serverSideBidCpmSum: [],
  serverSideBidResponseCpmSum: [],
}

export const ServerSideDetailPage: FunctionComponent = () => {
  const context = useAtomValue(contextState)
  const search = useSearchParams()
  const searchParams = JSON.parse(atob(search[0].get('mapping') ?? "{bidder: '', bidderName: ''}"))
  const { bidder } = searchParams
  const analyticsQueryTime = useAnalyticsQueryTanstack<ServerSideMetricsDetailByTime>('server-side.metrics.detail.by.time', DIMENSIONS, context, { bidderName: bidder })
  const breadcrumbs = useBreadcrumbs()
  const currencySymbol = useScopeCurrency()
  return (
    <AnalyticsPage onRefreshClick={() => {}} filterDimensions={DIMENSIONS} dashboard={SERVER_SIDE_DASHBOARD} title={breadcrumbs}>
      <PageContent>
        <ServerSideDetailCharts
          data={analyticsQueryTime.data ?? timelineEmptyData}
          onRefreshClick={() => {}}
          currencySymbol={currencySymbol}
          isLoading={analyticsQueryTime.isFetching}
          error={analyticsQueryTime.isError}
          empty={!analyticsQueryTime.isLoading && !analyticsQueryTime.data?.epoch.length}
          currentEpoch={DateTime.now()}
          timezone={context.timeRange.tz}
        />
        <ServerSideDetailBreakdown onRefreshClick={() => {}} currencySymbol={currencySymbol} dimensions={DIMENSIONS} bidderName={bidder} />
      </PageContent>
    </AnalyticsPage>
  )
}
